<template>
  <section class="section">
    <div class="container">
      <div class="section-head" v-reveal>
        <span class="section-eyebrow">OUR SERVICES</span>
        <h2 class="section-title">四大核心业务，<em>一站式</em>数字化交付</h2>
        <p class="section-sub">覆盖小程序、App、网站、系统四大领域，从前端到后端，从设计到上线。</p>
      </div>

      <div class="service-grid">
        <ServiceCard
          v-for="(s, i) in services"
          :key="s.id"
          :service="s"
          v-reveal="{ delay: i * 100 }"
        />
      </div>

      <div class="center-link" v-reveal>
        <router-link to="/services" class="btn btn-blue-outline">查看服务详情</router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import services from '@/data/services'
import ServiceCard from '@/components/ServiceCard.vue'
</script>

<style scoped>
.service-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.center-link {
  margin-top: 44px;
  text-align: center;
}

@media (max-width: 992px) {
  .service-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .service-grid {
    grid-template-columns: 1fr;
  }
}
</style>
